/**
 * 生成“附件”元素的 HTML
 * @param elem 附件元素，即上文的 myResume
 * @param childrenHtml 子节点的 HTML 代码，void 元素可忽略
 * @returns “@提及”元素的 HTML 字符串
 */
function mentionToHtml(elem) {
  const { value = '', userId = '' } = elem;
  return `<span data-w-e-type="mention" data-w-e-is-void data-w-e-is-inline data-user-id="${userId}" data-value="${value}">${value}</span>`;
}

// 配置
const conf = {
  type: 'mention', // 节点 type ，重要！！！
  elemToHtml: mentionToHtml
};

export default conf;
